module.exports = __webpack_public_path__ + "static/FabrigaMedium-e277cc26e1a780f6c217f3d1c7b49627.woff2";